(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* --header-height, measured OUTSIDE StickyHeader on purpose.
     It used to live only inside the custom element, which meant:
       1. with `Sticky header = None` (sections/header.liquid emits a plain <div>,
          not <sticky-header>) the element never upgraded and the variable was
          NEVER set on that store;
       2. it only ever re-ran on the 990px media-query change — never on load,
          never on resize. Measured consequence: at 1100px the bar is 104px (nav
          on two rows); resize to 1440 where it is 89px and the variable stayed
          at 104 because the 990 boundary was never crossed.
     The page layout no longer depends on this value (assets/pn-header.css floats
     the header out of flow), so it is now only the hero's content padding and the
     hide-on-scroll offset — a late or slightly-off value is cosmetic, not a jump.

     All identifiers are pn-prefixed: Shopify concatenates every section's
     javascript block into ONE shared scope, so a bare name here could collide
     with another section's. (Written without the literal tag name — theme-check
     parses a Liquid tag inside this block even from within a comment.) */
  let pnHeaderHeightRaf = null;

  function pnMeasureHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const height = header.offsetHeight;
    // A hidden or not-yet-laid-out header must never zero the variable — keeping
    // the previous value is always better than collapsing the offset to 0.
    if (!height) return;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  /* The announcement bar's height, for the floating header's `top` offset.

     Needed because <body> is a flex column and Shopify's section-group tag emits
     the bar and the header as two SEPARATE direct children of it — there is no
     group wrapper element to float as one stack. Per CSS Flexbox an absolutely-positioned child of a flex
     container takes its static position at the container's content-box origin,
     ignoring its siblings, so without this the floating header lands ON the bar.

     Unlike --header-height, a late or missing value here is cheap: it only slides
     the header down by the bar's height, it never moves the document. The CSS
     fallback carries the measured bar height so the very first paint is already
     right, and this only corrects for content that wraps at narrow widths.

     Written as 0px when no bar is rendered, so the same `top` expression serves
     both configurations and nothing has to branch. */
  function pnMeasureAnnouncementHeight() {
    const bar = document.querySelector('.announcement-bar-section');
    // getBoundingClientRect(), not offsetHeight: offsetHeight rounds to an integer,
    // and the bar measures 57.4px at 375 — the header then sat at 57 and a 0.4px
    // sliver of hero showed through between the two. Measured, not theoretical.
    document.documentElement.style.setProperty(
      '--pn-announcement-height',
      bar ? `${bar.getBoundingClientRect().height}px` : '0px'
    );
  }

  function pnScheduleHeaderHeight() {
    if (pnHeaderHeightRaf) return;
    pnHeaderHeightRaf = requestAnimationFrame(() => {
      pnHeaderHeightRaf = null;
      pnMeasureAnnouncementHeight();
      pnMeasureHeaderHeight();
    });
  }

  pnScheduleHeaderHeight();
  window.addEventListener('resize', pnScheduleHeaderHeight, { passive: true });
  window.addEventListener('load', pnScheduleHeaderHeight);
  if (document.fonts && document.fonts.ready) {
    // Webfont metrics change the bar's height after first layout.
    document.fonts.ready.then(pnScheduleHeaderHeight);
  }
  // Theme editor: a section re-render changes the bar.
  document.addEventListener('shopify:section:load', pnScheduleHeaderHeight);
  document.addEventListener('shopify:section:unload', pnScheduleHeaderHeight);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      pnMeasureHeaderHeight();
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
